import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from './icons/Icons';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'Llegué con manchas que llevaban años en mi cara. Después de 3 sesiones con Fernanda, no puedo creer lo que veo en el espejo. Es un lugar diferente — te hacen sentir especial.',
    author: 'Cliente de Philadelphia'
  }, {
    quote: 'El HydraFacial fue una experiencia increíble. Salí sintiéndome nueva. Fernanda es muy profesional y detallista. Ya soy cliente frecuente.',
    author: 'Cliente de Skin Glow Studio 22'
  }, {
    quote: 'Tenía mucho miedo de hacer el PRP pero Fernanda me explicó todo y me hizo sentir en confianza. Los resultados son reales. Mi piel rejuveneció notablemente.',
    author: 'Cliente frecuente'
  }, {
    quote: 'La IV Therapy me cambió la vida. Entré cansada, sin energía. Salí sintiéndome completamente renovada. Ahora es parte de mi rutina mensual.',
    author: 'Cliente de Skin Glow Studio 22'
  }];
  return <section id="testimonios" className="py-12 md:py-16 bg-brand-cream relative overflow-hidden" data-id="element-388">
      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-389">
        <div className="text-center mb-8 md:mb-10" data-id="element-390">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-391">
            Testimonios
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic" data-id="element-392">
            Historias reales. Resultados reales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-393">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-brand-cream relative" data-id="element-394">
              <div className="absolute top-8 right-8 text-brand-gold/10" data-id="element-395">
                <QuoteIcon size={60} data-id="element-396" />
              </div>

              <div className="flex space-x-1 mb-6 relative z-10" data-id="element-397">
                {[...Array(5)].map((_, i) => <div key={i} className="text-brand-gold" data-id="element-398">
                    <StarIcon size={18} fill="currentColor" data-id="element-399" />
                  </div>)}
              </div>

              <p className="text-lg text-brand-charcoal/80 leading-relaxed mb-8 relative z-10 italic" data-id="element-400">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center space-x-4 relative z-10" data-id="element-401">
                <div className="h-px w-8 bg-brand-gold" data-id="element-402"></div>
                <p className="text-sm font-medium text-brand-charcoal uppercase tracking-wider" data-id="element-403">
                  {testimonial.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};